import React, { useContext, useState } from "react"
import axios from 'axios'
import moment from 'moment';


const BASE_URL = "https://recup-api.tp-a.eu/api/v1/";


const GlobalContext = React.createContext()

export const GlobalProvider = ({children}) => {

    const [incomes, setIncomes] = useState([])
    const [expenses, setExpenses] = useState([])
    const [error, setError] = useState(null)

    //calculate incomes
    const addIncome = async (income) => {
        const response = await axios.post(`${BASE_URL}add-income`, income)
            .catch((err) =>{
                setError(err.response.data.message)
            })
        getIncomes()
    }

    const getIncomes = async () => {
        const response = await axios.get(`${BASE_URL}get-incomes`)
        setIncomes(response.data)
        console.log(response.data)
    }

    const deleteIncome = async (id) => {
        const res  = await axios.delete(`${BASE_URL}delete-income/${id}`)
        getIncomes()
    }

    const totalIncome = () => {
        let totalIncome = 0;
        incomes.forEach((income) =>{
            totalIncome = totalIncome + income.amount
        })

        return parseFloat(totalIncome).toFixed(2);
    }


    //calculate incomes
    const addExpense = async (income) => {
        const response = await axios.post(`${BASE_URL}add-expense`, income)
            .catch((err) =>{
                setError(err.response.data.message)
            })
        getExpenses()
    }

    const getExpenses = async () => {
        const response = await axios.get(`${BASE_URL}get-expenses`)
        setExpenses(response.data)
        console.log(response.data)
    }

    const deleteExpense = async (id) => {
        const res  = await axios.delete(`${BASE_URL}delete-expense/${id}`)
        getExpenses()
    }

    const totalExpenses = () => {
        let totalIncome = 0;
        incomes.forEach((income) =>{
            totalIncome = totalIncome + income.amountprime
        })

        return parseFloat(totalIncome).toFixed(2);
    }
    const moisPrecedent = (mois) => {
        let totalIncome = 0;
        incomes.forEach((income) =>{
            if(moment(income.date).isSame(mois, 'month'))
            totalIncome = totalIncome + income.amountprime
        })

        return parseFloat(totalIncome).toFixed(2);
    }
    const MoisEncours = (mois) => {
        let totalIncome = 0;
        incomes.forEach((income) =>{
            if(moment(income.date).isSame(mois, 'month'))
            totalIncome = totalIncome + income.amountprime
        })

        return parseFloat(totalIncome).toFixed(2);
    }
    const moisPrecedentR = (mois) => {
        let totalIncome = 0;
        incomes.forEach((income) =>{
            if(moment(income.date).isSame(mois, 'month'))
            totalIncome = totalIncome + income.amount
        })

        return parseFloat(totalIncome).toFixed(2);
    }
    const MoisEncoursR = (mois) => {
        let totalIncome = 0;
        incomes.forEach((income) =>{
            if(moment(income.date).isSame(mois, 'month'))
            totalIncome = totalIncome + income.amount
        })

        return parseFloat(totalIncome).toFixed(2);
    }
    const JourEncours = (jour) => {
        let totalIncome = 0;
        incomes.forEach((income) =>{
            if(moment(income.date).isSame(jour, 'day'))
            totalIncome = totalIncome + income.amountprime
        })

        return parseFloat(totalIncome).toFixed(2);
    }


    const totalBalance = () => {
        return totalIncome() - totalExpenses()
    }

    const transactionHistory = () => {
        const history = [...incomes, ...expenses]
        history.sort((a, b) => {
            return new Date(b.createdAt) - new Date(a.createdAt)
        })

        return history.slice(0, 3)
    }


    return (
        <GlobalContext.Provider value={{
            addIncome,
            getIncomes,
            incomes,
            deleteIncome,
            expenses,
            totalIncome,
            addExpense,
            getExpenses,
            deleteExpense,
            totalExpenses,
            totalBalance,
            transactionHistory,
            error,
            setError,
            moisPrecedent,
            MoisEncours,
            JourEncours,
            moisPrecedentR,
            MoisEncoursR
        }}>
            {children}
        </GlobalContext.Provider>
    )
}

export const useGlobalContext = () =>{
    return useContext(GlobalContext)
}